import { HeaderValuesType } from '@cxc/react-fpds-components';

const PDFTableColumnConstants: HeaderValuesType = [
    {
        id: 'grantor-name',
        textValue: 'Incentive Name',
        contentAlignment: 'left',
    },
    {
        id: 'incentive-description',
        textValue: 'Incentive Description',
        contentAlignment: 'left',
    },
    {
        id: 'scope-description',
        textValue: 'Project Scope Covered Under Program',
        contentAlignment: 'left',
    },
    {
        id: 'potential-value',
        textValue: 'Potential Incentive Value',
        contentAlignment: 'left',
    },
    {
        id: 'funding-cap-per-project',
        textValue: 'Funding Cap per Project',
        contentAlignment: 'left',
    },
    {
        id: 'link-to-grantor-site',
        textValue: 'Link to Grantor Site',
        contentAlignment: 'left',
    },
];

export default PDFTableColumnConstants;
